/* eslint-disable react/no-danger */
import React from "react";

import { Share, HeadingWIcon } from "@molecules";
import { Container, Divider, Text, ButtonAlt } from "@atoms";

import loadable from "@loadable/component";

const Video = loadable(() => import("../../components/atoms/Video"));
const Sidebar = loadable(() => import("@organisms/Sidebar"));

const VideoPage = ({ data, defaults, className }) => {
  const { url, hero, content, sidebar } = data;

  return (
    <div className={className}>
      <Container>
        {/* header */}
        <div className="-mx-4 mt-12 flex flex-wrap items-end md:-mx-10 md:mt-24">
          <div className="my-12 w-full px-4 md:px-10">
            <ButtonAlt noIcon={false} to="/resources" reverse>
              Go to All Resources
            </ButtonAlt>
          </div>
          <div className="w-full px-4 md:w-2/3 md:px-10">
            <HeadingWIcon {...hero} icon="sunrise" small />
            <Divider className="hidden md:block" />
          </div>
          <div className="w-full px-4 md:w-1/3">
            <div className="font-extended flex items-center">
              <Share url={url} />
            </div>
            <Divider className="hidden md:block" />
          </div>
        </div>
        {/* content */}
        <div className="-mx-4 mb-12 flex flex-wrap md:-mx-10">
          <div className="w-full px-4 pb-12 md:w-2/3 md:px-10">
            {content.embedCode && (
              <div
                dangerouslySetInnerHTML={{ __html: content.embedCode }}
                className="legacy-embed mb-12 mt-6"
              />
            )}
            {content.videoUrl && !content.embedCode && (
              <div className="mb-12 mt-6">
                <Video url={content.videoUrl} placeholder={content.image} />
              </div>
            )}
            <Text variant="body--large-tight" className="my-6">
              {content.copy}
            </Text>
          </div>
          {/* sidebar */}
          {sidebar && (
            <div className="w-full px-6 md:w-1/3">
              <Sidebar hideDivider {...sidebar} defaults={defaults} />
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

VideoPage.defaultProps = {};

export default VideoPage;
